/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadCommand
 */
export interface CreateLeadCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadCommand
     */
    email: string;
}

/**
 * Check if a given object implements the CreateLeadCommand interface.
 */
export function instanceOfCreateLeadCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function CreateLeadCommandFromJSON(json: any): CreateLeadCommand {
    return CreateLeadCommandFromJSONTyped(json, false);
}

export function CreateLeadCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function CreateLeadCommandToJSON(value?: CreateLeadCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

